import React from 'react';
import ReactDOM from 'react-dom/client';
import { bitable } from '@lark-base-open/js-sdk';
import App from './App';
import './styles/index.css';

// 主题适配
bitable.bridge.getTheme().then((theme) => {
    const root = document.documentElement;
    if (theme === 'DARK') {
        root.classList.add('semi-always-dark');
        document.body.setAttribute('theme-mode', 'dark');
    } else {
        root.classList.add('semi-always-light');
        document.body.setAttribute('theme-mode', 'light');
    }
});

// 监听主题变化
bitable.bridge.onThemeChange((event) => {
    const root = document.documentElement;
    root.classList.remove('semi-always-dark', 'semi-always-light');

    if (event.data.theme === 'DARK') {
        root.classList.add('semi-always-dark');
        document.body.setAttribute('theme-mode', 'dark');
    } else {
        root.classList.add('semi-always-light');
        document.body.setAttribute('theme-mode', 'light');
    }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
